// Sign-in returns `{ errors: [...] }`; forgot-password returns `{ errors: { base: [...] } }`.
export function authErrorMessage(body: any): string | null {
  const errors = body?.errors;

  if (Array.isArray(errors)) {
    return errors[0] ?? null;
  }

  return errors?.base?.[0] ?? null;
}

// Only the EHR refusal's message is meant for users; other server errors use our own copy.
const EHR_REFUSAL_STATUS = 403;

export function authError(status: number, body: any, fallback: string): string {
  return (status === EHR_REFUSAL_STATUS && authErrorMessage(body)) || fallback;
}
